import React, { useContext } from "react";
import { observer } from "mobx-react";
import { OfferStoreContext } from "@gp/components";

export const SideMenuLinkCount = observer(function SideMenuLinkCount(
	props: any
) {
	const { countKey } = props;

	// @ts-expect-error
	const count = useContext(OfferStoreContext)[countKey];

	if (!count || count <= 0) {
		return null;
	}

	return (
		<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
			{count}
		</span>
	);
});
